import { IssueType, IssueDetail } from "models/issue";
import { ResolutionInfo } from "models/resolutions";
import { missingAttributeResolution } from "./definitions/MissingAttribute";
import { missingEmailResolution } from "./definitions/MissingEmail";
import { missingMessageServiceResolution } from "./definitions/MissingMessageService";
import { missingMessageServiceUserResolution } from "./definitions/MissingMessageServiceUser";
import { unassignedRoleResolution } from "./definitions/UnassignedRole";
import { missingChannelResolution } from "./definitions/MissingChannel";
import { undeliveredResolution } from "./definitions/Undelivered";
import { unauthorizedMessageSenderResolution } from "./definitions/UnauthorizedMessageSender";
import { deactivatedSenderResolution } from "./definitions/DeactivatedSender";
import { deactivatedRecipientResolution } from "./definitions/DeactivatedRecipient";
import { useIssueDetailQuery } from "../hooks";

export const ISSUE_RESOLUTION_MAP: Record<IssueType, (issue: IssueDetail) => ResolutionInfo> = {
  missing_channel_membership: missingChannelResolution,
  missing_attribute: missingAttributeResolution,
  missing_email: missingEmailResolution,
  missing_message_service: missingMessageServiceResolution,
  missing_message_service_user: missingMessageServiceUserResolution,
  undelivered: undeliveredResolution,
  unassigned_role: unassignedRoleResolution,
  unauthorized_message_sender: unauthorizedMessageSenderResolution,
  deactivated_sender: deactivatedSenderResolution,
  deactivated_recipient: deactivatedRecipientResolution,
};

export function useIssueResolution(issue: IssueDetail | undefined): ResolutionInfo | Record<string, never> {
  const { data: issueDetail } = useIssueDetailQuery(issue?.id);
  if (!issueDetail) {
    return {};
  }
  const localIssueResolution = ISSUE_RESOLUTION_MAP[issueDetail?.issueType];
  return localIssueResolution(issueDetail);
}
